import { useState, useEffect } from "react";
import collapse from "../../static/images/downArrow.png";
import ReactMarkdown from "react-markdown";
import {
  ProjectCardButtonContainer,
  ProjectCardImageContainer,
} from "./ProjectCardElements";

export default function ProjectCard(props) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [projectDescription, setProjectDescription] = useState("");
  const projectDescriptionPath = props.content.projectDescriptionPath;

  useEffect(() => {
    fetch(projectDescriptionPath)
      .then((res) => res.text())
      .then((projectDescriptionRes) => {
        setProjectDescription(projectDescriptionRes);
      });
  });

  return (
    <div className="Project-card">
      <div className="Project-header">
        <div className="Project-title-text">
          <h1>{props.content.title}</h1>
          <h2>{props.content.subtitle}</h2>
          <ProjectCardImageContainer
            name="Project-media"
            imageRefs={props.content.projectImageRefs}
          />
        </div>
      </div>
      <div className="Project-card-project-icons">
        <ProjectCardImageContainer
          name="Project-icons"
          imageRefs={props.content.projectIconRefs}
        />
      </div>
      <hr />
      <div className="Project-content">
        <div
          className={`Project-content ${
            isCollapsed ? "collapsed" : "expanded"
          }`}
          aria-expanded={isCollapsed}
        >
          <ReactMarkdown children={projectDescription} />
          <ProjectCardButtonContainer buttonMap={props.content.buttonMap} />
        </div>
      </div>
      <button
        className="Project-collapse-button"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <img
          className="Project-title-collapse-button"
          src={collapse}
          alt="collapse content"
        />
      </button>
    </div>
  );
}
